import {useParams} from 'react-router-dom';
import {useGetBiotwinQuery} from '../../../app/services/biotwinApi';

export interface BiotwinDropdownProps {
  className?: string;
}

export const BiotwinDropdown = ({className}: BiotwinDropdownProps) => {
  const params = useParams<{userId: string}>();
  const userId = Number(params.userId);
  const {data: biotwin, error, isLoading} = useGetBiotwinQuery({id: userId}, {skip: !userId});

  if (!userId) {
    return null;
  }

  if (isLoading || error) {
    return null;
  }

  if (biotwin == null) {
    return null;
  }

  if (biotwin.id !== userId) {
    return null;
  }

  return <div className={className}>({biotwin.name})</div>;
};
